<script>
  import {translate} from "../../../../i18n/i18next.js";
  import {useMe} from "../../../../hooks/useMe.js";
  import {isServerAdmin} from "../../../../utils/user.js";
  import HelpTooltip from "../../../tooltip/HelpTooltip.svelte";

  const me = useMe()

  export let currentProjectPlan

  export let name
</script>

<div class="input-container">
  <label>
    <span>
      {translate("frontend:pages.projects.project.admin.sections.generalInfo.form.plan.label")}
      {#if currentProjectPlan === "auto-mps"}
        <HelpTooltip title="AutoMPSのプロジェクト">
          AutoMPSのプロジェクトとして作成された場合、あとからプロジェクトのプランを変更することはできません。新しいプロジェクトを作成してください。
        </HelpTooltip>
      {/if}
    </span>
    {#if currentProjectPlan === "auto-mps"}
      <!-- Once created, "AutoMPS" plan cannot be changed into another plan. -->
      <select disabled={true}>
        <option value="auto-mps">AutoMPS</option>
      </select>
    {:else}
      <select name={name} disabled={!isServerAdmin($me)}>
        <option value="free" selected={currentProjectPlan === "free"}>{translate("mySchedule.plans.free.name")}</option>
        <option value="viewer" selected={currentProjectPlan === "viewer"}>{translate("mySchedule.plans.viewer.name")}</option>
        <option value="standard" selected={currentProjectPlan === "standard"}>{translate("mySchedule.plans.standard.name")}</option>
      </select>
    {/if}
  </label>
  {#if !isServerAdmin($me)}
    <span class="supplemental-info">
      {translate("frontend:pages:projects.project.admin.sections.generalInfo.form.plan.caption")}
    </span>
  {/if}
</div>

<style>
  label {
    display: inline-flex;
    flex-direction: column;
    gap: 8px;
  }

  select {
    flex-grow: 1;
    font-size: 1rem;
    padding: 0.4rem;
    outline: none;
    border-radius: 5px;
    border: 1px solid lightgrey;
    background-color: white;
  }

  select:focus {
    outline: 2px solid #006bdf;
    outline-offset: -1px;
  }

  .input-container {
    display: flex;
    flex-direction: column;
  }
</style>
